import { serviceApi } from '../service';
import { capitalize } from '../../utils';

const CLIENT_URL = 'client';

export const clientJSONApi = {
  fetch: (options) => serviceApi.fetchJSON(CLIENT_URL, options),
};

export const clientApi = {
  fetch: (options) => serviceApi.fetch(CLIENT_URL, options),
};

export const updateClientDetails = ({
  title,
  firstName,
  lastName,
  phoneNumber,
  phoneNumberAlternative,
}) =>
  clientApi.fetch({
    method: 'PUT',
    body: {
      title,
      firstName: capitalize(firstName),
      lastName: capitalize(lastName),
      phoneNumber,
      phoneNumberAlternative,
    },
  });

export const getClientDetails = () => clientJSONApi.fetch();
